module.exports = __webpack_public_path__ + "img/head.30192a01.jpeg";